import React, { HTMLProps } from "react";

export const Button: React.FC<
  {
    id?: string;
    title?: string | null;
    url?: string | null;
    target?: string;
    selected?: boolean;
    transparent?: boolean;
  } & HTMLProps<HTMLAnchorElement>
> = ({
  id,
  title,
  url,
  target,
  selected,
  transparent,
  className,
  ...props
}) => {
  return (
    <a
      key={id}
      className={`
        text-md
        relative
        -left-1
        flex
        rounded-lg
        border
        border-beige
        px-3
        py-1
        font-bold
        lg:rounded-2xl
        lg:px-10
        lg:py-2
        lg:text-lg
        ${selected ? "bg-green" : !transparent ? " bg-white" : ""}
        ${className}
      `}
      href={url || undefined}
      target={target || "_blank"}
      {...props}
    >
      <div>{title}</div>
    </a>
  );
};
